import ValueInterface, { SerializedValueType } from "./ValueInterface"

export default class ConstantValue implements ValueInterface {
  constructor(
    private value: number,
    private readonly symbol: string,
  ) {}
  public toString(): string {
    return this.symbol
  }

  public normalize(): number {
    return this.value
  }

  public clone(): ValueInterface {
    throw new Error("Method not implemented.")
  }

  public toJSON(): SerializedValueType {
    return {
      type: "constant",
      payload: {
        value: this.value,
        symbol: this.symbol,
      },
    }
  }
}
